import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { Chart3dContextProvider } from 'lib/context/Chart3dContext/Chart3dContextProvider';
import { ClinicalNoteContextProvider } from 'lib/context/ClinicalNoteContext/ClinicalNoteContextProvider';
import { AmbientListeningContextProvider } from 'lib/context/MyScribeAI/AmbientListeningContext/AmbientListeningContextProvider';
import { MyScribeAIContextProvider } from 'lib/context/MyScribeAI/MyScribeAIContextProvider';
import { useClinicalNote } from 'lib/hooks/queries/clinicalNotes/useClinicalNotes';
import usePageTitle from 'lib/hooks/usePageTitle';

import {
  appointmentStatuses as aptStatuses,
  currentPractice
} from 'components/practice/practiceState';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

import HeaderActions from './components/HeaderActions';
import { defaultColumns, getPracticeDefaultFilters } from './lib/helper';

const ClinicalNotes = () => {
  usePageTitle('Clinical Notes');
  const navigate = useNavigate();
  const practice = useRecoilValue(currentPractice);
  const appointmentStatuses = useRecoilValue(aptStatuses);

  const columnDefs = useMemo(
    () => defaultColumns(practice?.timezone, appointmentStatuses),
    [practice?.timezone, appointmentStatuses]
  );

  const defaultFilters = useMemo(() => getPracticeDefaultFilters(practice), [practice]);

  const onSelectRow = async (data) => {
    navigate(`/portal/charts/${data?.appointment.user_id}/clinical-notes/${data?.appointment.id}`);
  };

  return (
    <ClinicalNoteContextProvider outsideClinicalNoteContext={true}>
      <Chart3dContextProvider>
        <MyScribeAIContextProvider>
          <AmbientListeningContextProvider>
            <AgTablePage
              defaultColumns={columnDefs}
              defaultFilters={defaultFilters}
              useData={useClinicalNote}
              name="clinical_notes_queue"
              queryKey="clinicalNote"
              title="Clinical Note"
              rowStyle={{ cursor: 'pointer' }}
              actions={HeaderActions}
              onSelectRow={onSelectRow}
              queryParams={{
                forPractice: true,
                withDocumentSign: true,
                withPatient: true,
                pagination: true
              }}
            />
          </AmbientListeningContextProvider>
        </MyScribeAIContextProvider>
      </Chart3dContextProvider>
    </ClinicalNoteContextProvider>
  );
};

export default withErrorBoundary(ClinicalNotes);
